import Icon from '../Icon';
import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error(error); // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement("h2", {
        className: "text-center",
        style: {
          color: 'crimson'
        }
      }, "Something went wrong.")), /*#__PURE__*/React.createElement(Card.Body, {
        className: "text-center"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "frown",
        size: 100,
        color: "crimson"
      })));
    } // Normally, just render children


    return this.props.children;
  }

}

export default ErrorBoundary;